<script lang="ts" generics="ITEM">
    import type {SearchManager} from '../search-manager/search-manager';
    import type {Observable} from 'rxjs';
    import type {SearchParams, ViewableSearch} from 'typings/portaro.be.types';
    import {exists} from 'shared/utils/custom-utils';

    export let searchManager: SearchManager<ITEM>;

    let lastSearch: Observable<ViewableSearch<SearchParams, ITEM>>;
    $: lastSearch = searchManager.getLastSearch$();
</script>

{#if exists($lastSearch)}
    <div class="search-page-footer">
        <slot lastSearch="{$lastSearch}"></slot>
    </div>
{/if}

<style lang="less">
    .search-page-footer {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        column-gap: 1em;
    }
</style>